// The guide's opening briefing is the first thing the player reads, and today
// it is only ever shown once: `CenterPanel` prints it as `narrativeText` until
// the next action overwrites it. `messageHistory` keeps it, so the Case File
// can show it again without any backend change.
//
// Three real entry shapes reach the client and all three are the briefing:
//   * pro-gen load  — `{action: null, target: null}`   (archive.py)
//   * featured load — `{action: 'opening', target: 'guide'}` (compat.py)
//   * fresh hydrate — `{action: 'opening', target: <guideId>}` (gameStore.js)
// The TUTORIAL ALSO PRODUCES A MATCHING ENTRY, so this helper does NOT skip it
// on its own: `TutorialPage.jsx:107` sets `messageHistory: []` and `:129`
// immediately calls `addMessage('opening', guideId, 'Welcome! ...')`, which the
// store stamps with `turnNumber: turnCount` — 0 at that point. Callers that
// must leave the tutorial alone gate on the store's `isTutorial` flag
// (`CaseFile.jsx` does).

const hasOpeningAction = (entry) => (
  entry.action === null || entry.action === undefined || entry.action === 'opening'
);

/**
 * The opening briefing entry in a message history, or `null`.
 *
 * Qualifies on the action shape AND on being the opening of the history —
 * `turnNumber === 0` or literally the first entry — so a later action entry
 * that happens to carry a null action can never be mistaken for the briefing.
 *
 * @param {Array<object>} messageHistory
 * @returns {{narrative: string, target: (string|null), turnNumber: number, timestamp: (string|undefined)}|null}
 */
export const findOpeningBriefing = (messageHistory) => {
  const history = Array.isArray(messageHistory) ? messageHistory : [];

  for (let index = 0; index < history.length; index += 1) {
    const entry = history[index];
    if (!entry || typeof entry.narrative !== 'string' || !entry.narrative.trim()) continue;
    if (!hasOpeningAction(entry)) continue;
    if (entry.turnNumber !== 0 && index !== 0) continue;

    return {
      narrative: entry.narrative,
      target: entry.target ?? null,
      turnNumber: entry.turnNumber ?? 0,
      timestamp: entry.timestamp,
    };
  }

  return null;
};
